<stages-card [contentCollapsible]="contentCollapsible">
	<!--  [toolbarId]="toolbarId" [toolbarItems]="toolbarItems" [menuId]="menuId" [menuItems]="menuItems" [menuNoCollapse]="menuNoCollapse"> -->
	<h5 [translate]="title"></h5>
	<ng-container stagesSlot="content" />
</stages-card>
